'use strict';

function parse(reader) {
    reader.readUInt8("data.ucp", value => value.toString(16));
    reader.readString(12, "data.sn");
    reader.readString(4, "data.hardware");
    reader.readString(4, "data.firmware");
    reader.readString(4, "data.model");
    reader.readString(16, "data.imei");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/uart/attribute-report-parser.js